import { createRouter, createWebHistory } from 'vue-router';
import {
  CALLBACK, CHECK_AUTH, LOGOUT,
} from '@/store/actions.type';
import { destroyUrlReferer, getUrlReferer } from '@/common/referer.service';
import store from '@/store';
import { saveToken } from '@/common/jwt.service';
import Home from '@/views/Home.vue';
import ProductsView from '@/views/ProductsView.vue';
import ProductView from '@/views/ProductView.vue';
import i18n from '@/i18n';
import { h, resolveComponent } from 'vue';
import Logout from '@/views/Logout.vue';

const routes = [
  {
    path: '/:locale',
    name: 'default',
    component: {
      render() {
        return h(resolveComponent('router-view'));
      },
    },
    beforeEnter: (to, from, next) => {
      const { locale } = to.params;
      const supportedLocales = process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(',');
      if (!supportedLocales.includes(locale)) return next('en');
      if (i18n.locale !== locale) {
        localStorage.setItem('lang', locale);
        i18n.global.locale = locale;
      }
      return next();
    },
    children: [
      {
        path: '',
        name: 'Home',
        component: Home,
        meta: { transition: 'fade-outfade-out' },
      },
      {
        path: ':productCategory',
        component: ProductsView,
        name: 'ProductsView',
        children: [
          {
            path: ':product',
            component: ProductView,
            name: 'ProductView',
          },
        ],
      },
    ],
  },
  {
    path: '/samlredirect/:token',
    name: 'redirect',
    beforeEnter: (to, from, next) => {
      saveToken(to.params.token);
      store.dispatch(CHECK_AUTH)
        .then(() => {
          const refererUrl = getUrlReferer();
          next({ path: refererUrl });
        });
    },
    meta: {
      title: 'SAML Redirect',
    },
  },
  {
    path: '/logout',
    name: 'Logout',
    meta: {
      needGuard: false,
      title: 'logout',
    },
    component: Logout,
    beforeEnter: () => store.dispatch(LOGOUT),
  },
  {
    path: '/callback-login',
    name: 'Callback-login',
    // route level code-splitting
    beforeEnter: (to, from, next) => store.dispatch(CALLBACK,
      { code: to.query.code })
      .then(() => {
        const refererUrl = getUrlReferer();
        if (refererUrl) {
          destroyUrlReferer();
          return next(refererUrl);
        }
        return next('/');
      })
      .catch(() => {
        store.dispatch(LOGOUT).then();
      }),
    meta: {
      needGuard: false,
      title: 'login',
    },
  },
  {
    path: '/403',
    component: () => import(/* webpackChunkName: "about" */ '../views/AccessDenied.vue'),
    meta: {
      needGuard: false,
      title: 'AccessDenied',
    },
  },
  { // <---------------
    path: '/:catchAll(.*)',
    redirect() {
      return i18n.locale ?? 'fr';
    },
  },
];

const router = createRouter({
  base: process.env.BASE_URL,
  history: createWebHistory(),
  mode: 'history',
  routes,
});

export default router;
